import React from "react";
import { Avatar, makeStyles } from "@material-ui/core";
import { getDownloadableLink } from "../../../Helper";

const styles = makeStyles({
  card: {
    "& .contact-info": {
      display: "flex",
      justifyContent: "space-between",
      border: "1px solid #EAECF0",
      borderRadius: "12px",
      padding: "15px 16px",
      marginTop: "8px",
      gap: "10px",
      "& div": {
        marginBottom: "4px",
        "& label": {
          fontWeight: "bold",
          marginRight: "4px",
          color: "#555",
        },
      },
      "& .contact-info-item": {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        "& span": {
          color: "#475467",
          fontSize: "14px",
          fontWeight: 500,
        },
        "& strong": {
          color: "#101828",
          fontSize: "14px",
          fontWeight: 600,
          gap: "10px",
          "& .small-avatar": {
            width: "24px",
            height: "24px",
          },
        },
      },
    },
  },
});
const ContactAndLeadInfo = ({ contact }) => {
  const classes = styles();
  return (
    <div className={classes.card}>
      <div className="contact-info">
        <div className="contact-info-item">
          <span>Contact name</span>

          <strong className="flex gap-10 fa-center">
            {contact?.contact?.company_logoimage && (
              <Avatar
                src={getDownloadableLink(
                  contact?.contact.company_logoimage?.["Company Logo"]?.[0].uuid
                )}
                className="small-avatar"
              />
            )}{" "}
            {contact?.contact?.company_name ??
              [contact?.contact?.first_name, contact?.contact?.last_name].join(
                " "
              ) ??
              "-"}
          </strong>
        </div>
        <div className="contact-info-item">
          <span>Contact email</span>
          <strong>
            {contact?.contact?.email_address?.email ??
              contact?.contact?.general_email?.email ??
              contact?.details?.find((d) => d.title === "email")?.value}
          </strong>
        </div>
        <div className="contact-info-item">
          <span>Contact phone number</span>
          <strong>
            {contact?.contact?.landline_number?.phone ??
              contact?.contact?.mobile?.phone ??
              contact?.details?.find((d) => d.title === "mobile")?.value}
          </strong>
        </div>
      </div>
    </div>
  );
};
export default ContactAndLeadInfo;
